<template>
  <el-dialog title="添加帳戶" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" class="dialogEdit">
     <el-form :model="form">
          <el-form-item label="帳戶名">
            <el-input placeholder="請輸入帳戶名" v-model="form.username"></el-input>
          </el-form-item>
           <el-form-item label="帳戶">
            <el-input placeholder="請輸入手機號" v-model="form.mobile"></el-input>
          </el-form-item>
           <el-form-item label="密碼">
            <el-input placeholder="請輸入密碼" v-model="form.password" type="password"></el-input>
          </el-form-item>
          <!-- <el-form-item label="類型">
            <el-select v-model="ruleForm.type" placeholder="請選擇分類">
              <el-option label="編輯" value="0"></el-option>
              <el-option label="管理员" value="1"></el-option>
            </el-select>
          </el-form-item> -->
         

        </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "author_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      form: {
        username: "",
        mobile: "",
        password: "",
      }
    };
  },
  methods: {
    show(value) {
      this.dialogVisible = true;
      if (value !== undefined) {
        this.form = Object.assign({}, value);
      } else {
        this.form = { name: "", mobile:'',password:'' };
      }
    },
    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);
      this.$http.post("/admin/adminUser/edit", params).then(res => {
        self.$emit("sucess");
        this.dialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less">
.dialogEdit{
    text-align:left;
    
}
</style>